import React, { useEffect, useState } from 'react';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { useDispatch, useSelector } from 'react-redux';
import { SelectableList } from 'components/UI';

import { userGroupsActions } from 'state/modules/userGroups';
import { uiActions } from 'state/modules/UI';
import i18n from 'i18n-js';

import useStyles from './UserGroupsParents.styled';

const UserGroupsParents = ({ currentUserGroup, step, center = true }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { fetchedAddItem, fetchedRemoveParent, loading, error } = useSelector(
    (state) => state.userGroups
  );
  const [isAssignedSelected, setAssignedSelected] = useState(false);
  const [isAvailableSelected, setAvailableSelected] = useState(false);

  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    user_group_type: ['EMPLOYEE', 'BUSINESS', 'CONTRACTOR'],
  });
  const [currentParentsParams, setCurrentParentsParams] = useState({
    page: 1,
    limit: 10,
  });
  const [assignedParents, setAssignedParents] = useState([]);
  const [availablesParents, setAvailablesParents] = useState([]);
  const [selectedParentRow, setSelectedAvailablesRow] = useState(null);

  const availablesParentsColumns = [
    {
      name: i18n.t('user_groups.parent.name'),
      selector: 'name',
      sortable: false,
    },
    {
      name: i18n.t('user_groups.parent.type'),
      selector: 'user_group_type',
      sortable: false,
    },
    {
      name: i18n.t('user_groups.parent.status'),
      selector: 'status',
      sortable: false,
    },
  ];

  const assignedParentsColumns = [
    {
      name: i18n.t('user_groups.parent.name'),
      selector: 'name',
      sortable: false,
    },
    {
      name: i18n.t('user_groups.parent.type'),
      selector: 'user_group_type',
      sortable: false,
    },
    {
      name: i18n.t('user_groups.parent.status'),
      selector: 'status',
      sortable: false,
    },
  ];

  const addParentToUserGroup = () => {
    if (!selectedParentRow) {
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: i18n.t('user_groups.parent.empty'),
        })
      );
    }
    const payload = {
      parent_id: selectedParentRow,
    };
    setAvailableSelected(false);

    dispatch(userGroupsActions.fetchAddParetToUserGroup(currentUserGroup?.id, payload));
  };

  const removeParentToUserGroup = () => {
    if (!selectedParentRow) {
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: i18n.t('user_groups.select_parent_before_remove_from_user_group'),
        })
      );
    }

    setAssignedSelected(false);
    const payload = {
      parent_id: selectedParentRow,
    };
    dispatch(userGroupsActions.fetchRemoveParentFromUserGroup(currentUserGroup.id, payload));
  };

  const fetchAvailableParents = (params = {}) => {
    dispatch(userGroupsActions.fetchAvailablesParents(params));
  };

  const fetchParents = (params = {}) => {
    dispatch(userGroupsActions.fetchParents(currentUserGroup?.id, params));
  };

  useEffect(() => {
    if (currentUserGroup) {
      fetchParents(currentParentsParams);
    }
  }, [dispatch, currentUserGroup, currentParentsParams]); // eslint-disable-line

  useEffect(() => {
    dispatch(userGroupsActions.fetchAvailablesParents(params));
  }, [dispatch, params]);

  useEffect(() => {
    if (fetchedAddItem || fetchedRemoveParent) {
      fetchParents(currentParentsParams);
    }
    if (fetchedRemoveParent) {
      setAvailableSelected(false);
      onAvailablesRowClicked(null);
      setAvailablesParents(filteredParents() || []);
    }
  }, [fetchedAddItem, fetchedRemoveParent]); // eslint-disable-line

  useEffect(() => {
    if (!fetchedRemoveParent && error?.removeItem) {
      setAssignedSelected(true);
    }
  }, [fetchedRemoveParent, error]);

  useEffect(() => {
    if (step?.parents?.list?.length > 0) {
      setAssignedParents(filteredAssigndParents() || []);
    }

    if (step?.availables?.list?.length > 0) {
      setAvailablesParents(filteredParents() || []);
    }

    setSelectedAvailablesRow(null);
  }, [step]); // eslint-disable-line

  const filteredParents = () => {
    const parents = [...(step?.availables?.list || [])];
    const assignedParents = [...(step?.parents?.list || [])];

    const filteredArray = parents.map((parent) => {
      parent.disabled = false;
      parent.selected = false;
      if (assignedParents?.length === 0) {
        return parent;
      } else {
        for (let i = 0; i < assignedParents.length; i++) {
          if (assignedParents[i]?.id === parent?.id || parent?.id === currentUserGroup?.id) {
            parent.disabled = true;
          }
        }
        return parent;
      }
    });

    return filteredArray;
  };

  const filteredAssigndParents = () => {
    const parents = [...(step?.parents?.list || [])];

    const filteredArray = parents.map((parent) => {
      if (parent?.user_group_type === 'PARENT') {
        parent.disabled = true;
      }
      return parent;
    });

    return filteredArray;
  };

  const onAvailablesRowClicked = (row) => {
    setSelectedAvailablesRow(row?.id);
  };

  const handlePageChange = (page) => {
    const newParams = { ...params, page, limit: params.limit };
    setParams(newParams);
    fetchAvailableParents(newParams);
  };

  const handlePerRowsChange = async (limit) => {
    const newParams = { ...params, page: 1, limit: limit };
    setParams(newParams);
    fetchAvailableParents(newParams);
  };

  const parentsHandlePageChange = (page) => {
    const newParams = { ...currentParentsParams, page, limit: params.limit };
    setCurrentParentsParams(newParams);
    fetchParents(newParams);
  };

  const parentsHandlePerRowsChange = async (limit) => {
    const newParams = { ...currentParentsParams, page: 1, limit: limit };
    setCurrentParentsParams(newParams);
    fetchParents(newParams);
  };

  return (
    <Box className={classes.container}>
      <Container className="h-100">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <Typography gutterBottom component="div" align={center ? 'center' : 'left'}>
              <Box fontWeight="fontWeightBold" fontSize={14} my={2}>
                {i18n.t('user_groups.parent.select')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-around" alignItems="flex-start">
              <Grid item xs={5}>
                <SelectableList
                  mainTable={true}
                  title={i18n.t('user_groups.parent.available')}
                  columns={availablesParentsColumns}
                  dataCy={'available'}
                  data={availablesParents || []}
                  loading={step?.availables?.loading}
                  handlePageChange={handlePageChange}
                  onRowClicked={(row) => {
                    setAvailableSelected(!!row);
                    onAvailablesRowClicked(row);
                  }}
                  handlePerRowsChange={handlePerRowsChange}
                  pagination={true}
                  totalRows={step?.availables?.pagination?.totalRows || 0}
                />
              </Grid>
              <Grid item xs={2}>
                <Box
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  justifyContent="center"
                >
                  <Box py={1} px={2} style={{ width: '100%' }}>
                    <Button
                      data-cy="add-btn"
                      onClick={addParentToUserGroup}
                      disabled={loading || !isAvailableSelected}
                      variant="outlined"
                      color="primary"
                      fullWidth
                    >
                      {i18n.t('common.add')}
                    </Button>
                  </Box>
                  <Box py={1} px={2} style={{ width: '100%' }}>
                    <Button
                      onClick={removeParentToUserGroup}
                      disabled={loading || !isAssignedSelected}
                      variant="outlined"
                      color="primary"
                      fullWidth
                    >
                      {i18n.t('common.remove')}
                    </Button>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={5}>
                <Box mb={5}>
                  <SelectableList
                    loading={step?.parents?.loading}
                    dataCy={'parents'}
                    handlePageChange={parentsHandlePageChange}
                    handlePerRowsChange={parentsHandlePerRowsChange}
                    pagination={true}
                    data={assignedParents || []}
                    title={i18n.t('user_groups.parent.parent_groups')}
                    columns={assignedParentsColumns}
                    totalRows={step?.parents?.pagination?.totalRows || 0}
                    onRowClicked={(row) => {
                      setAssignedSelected(!!row);
                      onAvailablesRowClicked(row);
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default UserGroupsParents;
